import { ShieldAlert, LogOut, ExternalLink } from "lucide-react";
import { Button } from "@wa/ui";
import { useT } from "../i18n/I18nProvider";
import { ADMIN_URL, logout, type StaffUser } from "../lib/auth";
import { BrandLogo } from "../components/BrandLogo";
import { AppBackground } from "../components/AppBackground";

/**
 * Staff-CRM = platvormi-tööriist. Kui sisselogitud kasutaja EI ole host-staff
 * (mitte superadmin ega host-membership), näitame keeldumist + viite konto-hubi/
 * editorisse - mitte tühja CRM-i.
 */
export function AccessDenied({ user, onLogout }: { user: StaffUser; onLogout: () => void }) {
  const t = useT();

  async function doLogout() {
    await logout().catch(() => {});
    onLogout();
  }

  return (
    <main className="relative isolate flex min-h-dvh items-center justify-center overflow-hidden px-4 py-12">
      <AppBackground intensity={45} />
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <BrandLogo className="h-7 w-auto text-foreground" />
        </div>
        <div className="card-aurora-border flex flex-col items-center gap-4 rounded-xl bg-card/90 p-8 text-center shadow-soft backdrop-blur">
          <div className="inline-flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
            <ShieldAlert className="size-6" />
          </div>
          <h1 className="text-xl font-bold tracking-tight">{t("denied.title")}</h1>
          <p className="text-sm text-muted-foreground">{t("denied.body", { email: user.email })}</p>
          <div className="flex flex-wrap items-center justify-center gap-2 pt-1">
            <Button variant="outline" asChild>
              <a href={ADMIN_URL}>
                <ExternalLink className="size-4" />
                {t("denied.toAdmin")}
              </a>
            </Button>
            <Button variant="ghost" onClick={doLogout}>
              <LogOut className="size-4" />
              {t("app.logout")}
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}
